<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-full bg-gradient-to-br from-primary-500 to-primary-600 flex items-center justify-center">
          <i class="pi pi-heart text-white text-lg"></i>
        </div>
        <div>
          <span class="text-lg font-bold text-surface-900 dark:text-surface-50">Spende</span>
          <p class="text-xs text-surface-600 dark:text-surface-400">Unterstütze lokale Vereine</p>
        </div>
      </div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="donation-sheet-content">
  <div class="p-5">
    <form [formGroup]="donationForm" (ngSubmit)="submitDonation()">
      <!-- Amount Selection -->
      <div class="mb-5">
        <label class="block text-sm font-semibold text-surface-900 dark:text-surface-50 mb-3">
          Spendenbetrag
        </label>
        
        <!-- Predefined Amounts -->
        <div class="grid grid-cols-4 gap-2 mb-3">
          <button 
            *ngFor="let amount of predefinedAmounts"
            type="button"
            (click)="selectPredefinedAmount(amount.value)"
            [ngClass]="{
              'ring-2 ring-primary-500 bg-primary-50 dark:bg-primary-900/20': selectedPredefinedAmount === amount.value
            }"
            class="px-3 py-2.5 rounded-lg border border-surface-300 dark:border-surface-600 
                 hover:border-primary-400 dark:hover:border-primary-500 transition-all
                 text-sm font-semibold text-surface-900 dark:text-surface-50">
            {{ amount.label }}
          </button>
        </div>

        <!-- Custom Amount Input -->
        <div class="relative">
          <input 
            type="number" 
            formControlName="amount"
            (input)="onAmountChange()"
            min="100"
            step="100"
            class="w-full px-4 py-3 pr-12 rounded-lg border border-surface-300 dark:border-surface-600 
                   focus:ring-2 focus:ring-primary-500 focus:border-primary-500
                   bg-white dark:bg-surface-800 text-surface-900 dark:text-surface-50"
            placeholder="Eigener Betrag (min. 1 €)">
          <div class="absolute right-4 top-1/2 -translate-y-1/2 text-sm text-surface-500 dark:text-surface-400">
            SC
          </div>
        </div>
        <p class="text-xs text-surface-600 dark:text-surface-400 mt-2">
          = {{ amountInEuros | currency:'EUR':'symbol':'1.2-2':'de' }}
        </p>
      </div>

      <!-- Organization Selection -->
      <div class="mb-5">
        <label class="block text-sm font-semibold text-surface-900 dark:text-surface-50 mb-2">
          Organisation auswählen
        </label>
        <p-select 
          formControlName="businessHubId"
          [options]="evHubs"
          optionLabel="name"
          optionValue="id"
          placeholder="Verein auswählen"
          [loading]="isLoading"
          styleClass="w-full"
          [filter]="true"
          filterPlaceholder="Suchen...">
          <ng-template let-hub pTemplate="item">
            <div class="flex items-center gap-3 py-2">
              <img 
                *ngIf="hub.avatar" 
                [src]="hub.avatar" 
                [alt]="hub.name"
                class="w-10 h-10 rounded-full object-cover"
                onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'">
              <div 
                *ngIf="!hub.avatar"
                class="w-10 h-10 rounded-full bg-primary-100 dark:bg-primary-900/30 
                       flex items-center justify-center text-primary-600 dark:text-primary-400 font-bold">
                {{ hub.name.charAt(0) }}
              </div>
              <div class="flex-1 min-w-0">
                <p class="text-sm font-semibold text-surface-900 dark:text-surface-50 truncate">
                  {{ hub.name }}
                </p>
                <p class="text-xs text-surface-600 dark:text-surface-400">
                  {{ hub.city }} · {{ hub.totalDonationsInEuros | currency:'EUR':'symbol':'1.0-0':'de' }} gespendet
                </p>
              </div>
            </div>
          </ng-template>
        </p-select>
      </div>

      <!-- Message (Optional) -->
      <div class="mb-5">
        <label class="block text-sm font-semibold text-surface-900 dark:text-surface-50 mb-2">
          Nachricht (optional)
        </label>
        <textarea 
          formControlName="message"
          rows="3"
          maxlength="500"
          class="w-full px-4 py-3 rounded-lg border border-surface-300 dark:border-surface-600 
                 focus:ring-2 focus:ring-primary-500 focus:border-primary-500
                 bg-white dark:bg-surface-800 text-surface-900 dark:text-surface-50 resize-none"
          placeholder="Hinterlasse eine Nachricht (max. 500 Zeichen)">
        </textarea>
        <p class="text-xs text-surface-600 dark:text-surface-400 mt-1 text-right">
          {{ donationForm.get('message')?.value?.length || 0 }} / 500
        </p>
      </div>

      <!-- Anonymous Checkbox -->
      <div class="mb-6">
        <label class="flex items-center gap-2 cursor-pointer">
          <p-checkbox 
            formControlName="isAnonymous"
            [binary]="true"
            inputId="anonymous">
          </p-checkbox>
          <span class="text-sm text-surface-900 dark:text-surface-50">
            Anonym spenden
          </span>
        </label>
      </div>

      <!-- Submit Button -->
      <div class="flex gap-3">
        <p-button 
          type="button"
          label="Abbrechen"
          (onClick)="close()"
          [outlined]="true"
          severity="secondary"
          styleClass="flex-1">
        </p-button>
        <p-button 
          type="submit"
          [label]="isSubmitting ? 'Wird gespendet...' : 'Jetzt spenden'"
          [loading]="isSubmitting"
          [disabled]="donationForm.invalid || isSubmitting"
          icon="pi pi-heart"
          styleClass="flex-1">
        </p-button>
      </div>
    </form>
  </div>
</ion-content>